// Values must match V0::ClaimsEvidenceController::DOCUMENT_TYPES
// in vets-api
export const SUPPLEMENTAL_CLAIM_DOC_TYPES_FALLBACK = [
  { value: '26', label: 'Buddy/Lay Statement' },
  {
    value: '40',
    label: 'Certificate of Release or Discharge From Active Duty (DD214)',
  },
  { value: '29', label: 'Civilian Police Reports' },
  { value: '34', label: 'Correspondence' },
  {
    value: '702',
    label: 'Disability Benefits Questionnaire (DBQ) - Veteran Provided',
  },
  { value: '703', label: 'Goldmann Perimetry Chart/Field of Vision Chart' },
  { value: '58', label: 'Medical Treatment Record - Government Facility' },
  { value: '59', label: 'Medical Treatment Record - Non-Government Facility' },
  { value: '478', label: 'Medical Treatment Records - Furnished by SSA' },
  { value: '45', label: 'Military Personnel Record' },
  { value: '80', label: 'Photographs' },
  { value: '375', label: 'VA Form 21-0779' },
  { value: '381', label: 'VA Form 21-0781' },
  { value: '382', label: 'VA Form 21-0781a' },
  { value: '111', label: 'VA Form 21-2680' },
  { value: '124', label: 'VA Form 21-4192' },
  { value: '126', label: 'VA Form 21-4502' },
  { value: '142', label: 'VA Form 21-674 (Report of School Attendance)' },
  { value: '148', label: 'VA Form 21-686c' },
  { value: '158', label: 'VA Form 21-8940' },
  { value: '168', label: 'VA Form 26-4555' },
];

export const DOC_TYPE_MAP = new Map(
  SUPPLEMENTAL_CLAIM_DOC_TYPES_FALLBACK.map(doc => [doc.value, doc.label]),
);
